<template>
  <v-card>
    <v-card-title class="pt-5 pl-6">
      <span class="table-card-title">Disparos</span>
    </v-card-title>
    <v-card-text>
      <v-data-table :items="channelTriggerItems" :headers="channelTriggerHeader" :loading="loading" hide-default-footer disable-pagination>
        <template v-for="headerTooltip in headersTooltip" v-slot:[headerTooltip.slot]="{ header }">
          <v-tooltip :key="headerTooltip.slot" bottom max-width="192px">
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ header.text }}</span>
            </template>
            <span>{{ headerTooltip.text }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <messages-history
                v-if="shouldShowMessageHistory(item.channel)"
                :campaign-id="campaign._id"
                :show-cost="true"
                :query="query"
                :history-type="item.channel"
              />
              <span v-else>{{ item.channel }}</span>
            </td>
            <td>{{ item.customers.toLocaleString('pt-BR') }}</td>
            <td>{{ item.shots.toLocaleString('pt-BR') }}</td>
            <td>{{ item.received.toLocaleString('pt-BR') }}</td>
            <td>{{ item.delivery }}</td>
            <td>
              {{ locale(item.cost, 2) | localeString(2) | currency }}
            </td>
            <td>{{ locale(item.revenues, 2) | localeString(2) | currency }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { localeString, putEmptyValue } from '@/config/helpers.js'
import { QUERY_CHANNEL_SHOOTING_HISTORY } from '@/modules/maria/campanha-da-maria-v2/graphql'
import { mariaResults } from '@/modules/maria/campanha-da-maria-v2/mixins/maria-results'

export default {
  name: 'ChannelTriggers',

  components: {
    MessagesHistory: () => import('@/modules/campanhas/views/components/results/MessagesHistory.vue'),
  },

  mixins: [mariaResults],

  props: {
    metrics: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    locale: localeString,
  }),

  computed: {
    headersTooltip() {
      return [
        {
          slot: 'header.customers',
          text: 'Quantidade de clientes únicos que receberam disparos desse canal.',
        },
        {
          slot: 'header.shots',
          text: 'Quantidade de disparos efetuados por esse canal.',
        },
        {
          slot: 'header.received',
          text: 'Quantidade de disparos desse canal que foram recebidos.',
        },
        {
          slot: 'header.delivery',
          text: 'Porcentagem dos disparos efetuados que foram entregues.',
        },
        {
          slot: 'header.cost',
          text: 'Custo total desses disparos.',
        },
        {
          slot: 'header.revenues',
          text: 'Faturamento gerado pelos clientes que receberam disparos desse canal.',
        },
      ]
    },
    query() {
      return QUERY_CHANNEL_SHOOTING_HISTORY
    },
    channelTriggerItems() {
      return [
        ...(!this.isChannelActivated('sms')
          ? []
          : [
              {
                channel: 'SMS',
                customers: this.putEmptyValueInDeactivatedChannel(this.putEmptyValue(this.metrics.clients_metrics.channels?.sms.received.count, '-'), 'sms'),
                shots: this.putEmptyValueInDeactivatedChannel(this.putEmptyValue(this.metrics.general_metrics.channels?.sms.sent.messages, '-'), 'sms'),
                received: this.putEmptyValueInDeactivatedChannel(this.putEmptyValue(this.metrics.general_metrics.channels?.sms.received.messages, '-'), 'sms'),
                delivery: `${this.putEmptyValueInDeactivatedChannel(
                  this.putEmptyValue(
                    parseInt((this.metrics.general_metrics.channels?.sms.received.messages / this.metrics.general_metrics.channels?.sms.sent.messages) * 100),
                    0
                  ),
                  'sms'
                )}%`,
                cost: this.putEmptyValueInDeactivatedChannel(this.putEmptyValue(this.metrics.analytic_metrics.channels?.sms.price, '-'), 'sms'),
                revenues: this.putEmptyValueInDeactivatedChannel(this.metrics.clients_metrics?.channels?.sms.received_and_bought.revenue, 'sms'),
              },
            ]),
        ...(!this.isChannelActivated('whatsapp')
          ? []
          : [
              {
                channel: 'Whatsapp',
                customers: this.putEmptyValueInDeactivatedChannel(
                  this.putEmptyValue(this.metrics.clients_metrics.channels?.whatsapp.received.count, '-'),
                  'whatsapp'
                ),
                shots: this.putEmptyValueInDeactivatedChannel(
                  this.putEmptyValue(this.metrics.general_metrics.channels?.whatsapp.sent.messages, '-'),
                  'whatsapp'
                ),
                received: this.putEmptyValueInDeactivatedChannel(
                  this.putEmptyValue(this.metrics.general_metrics.channels?.whatsapp.received.messages, '-'),
                  'whatsapp'
                ),
                delivery: `${this.putEmptyValueInDeactivatedChannel(
                  this.putEmptyValue(
                    parseInt(
                      (this.metrics.general_metrics.channels?.whatsapp.received.messages / this.metrics.general_metrics.channels?.whatsapp.sent.messages) * 100
                    ),
                    0
                  ),
                  'whatsapp'
                )}%`,
                cost: this.putEmptyValueInDeactivatedChannel(this.putEmptyValue(this.metrics.analytic_metrics.channels?.whatsapp.price, '-'), 'whatsapp'),
                revenues: this.putEmptyValueInDeactivatedChannel(this.metrics.clients_metrics?.channels?.whatsapp.received_and_bought.revenue, 'whatsapp'),
              },
            ]),
        ...(!this.isChannelActivated('email')
          ? []
          : [
              {
                channel: 'E-mail',
                customers: this.putEmptyValueInDeactivatedChannel(
                  this.putEmptyValue(this.metrics.clients_metrics.channels?.email.received.count, '-'),
                  'email'
                ),
                shots: this.putEmptyValueInDeactivatedChannel(this.putEmptyValue(this.metrics.general_metrics.channels?.email.sent.messages, '-'), 'email'),
                received: this.putEmptyValueInDeactivatedChannel(
                  this.putEmptyValue(this.metrics.general_metrics.channels?.email.received.messages, '-'),
                  'email'
                ),
                delivery: `${this.putEmptyValueInDeactivatedChannel(
                  this.putEmptyValue(
                    parseInt(
                      (this.metrics.general_metrics.channels?.email.received.messages / this.metrics.general_metrics.channels?.email.sent.messages) * 100
                    ),
                    0
                  ),
                  'email'
                )}%`,
                cost: this.putEmptyValueInDeactivatedChannel(this.putEmptyValue(this.metrics.analytic_metrics.channels?.email.price, '-'), 'email'),
                revenues: this.putEmptyValueInDeactivatedChannel(this.metrics.clients_metrics?.channels?.email.received_and_bought.revenue, 'email'),
              },
            ]),
        ...(!this.isChannelActivated('push')
          ? []
          : [
              {
                channel: 'Push aplicativo',
                customers: this.putEmptyValueInDeactivatedChannel(this.putEmptyValue(this.metrics.clients_metrics.channels?.push.received.count, '-'), 'push'),
                shots: this.putEmptyValueInDeactivatedChannel(this.putEmptyValue(this.metrics.general_metrics.channels?.push.sent.messages, '-'), 'push'),
                received: this.putEmptyValueInDeactivatedChannel(
                  this.putEmptyValue(this.metrics.general_metrics.channels?.push.received.messages, '-'),
                  'push'
                ),
                delivery: `${this.putEmptyValueInDeactivatedChannel(
                  this.putEmptyValue(
                    parseInt((this.metrics.general_metrics.channels?.push.received.messages / this.metrics.general_metrics.channels?.push.sent.messages) * 100),
                    0
                  ),
                  'push'
                )}%`,
                cost: this.putEmptyValueInDeactivatedChannel(this.putEmptyValue(this.metrics.analytic_metrics.channels?.push.price, '-'), 'push'),
                revenues: this.putEmptyValueInDeactivatedChannel(this.metrics.clients_metrics?.channels?.push.received_and_bought.revenue, 'push'),
              },
            ]),
      ]
    },
    channelTriggerHeader() {
      return [
        {
          text: 'Canal',
          value: 'channel',
          width: '14.28%',
        },
        {
          text: 'Clientes',
          value: 'customers',
          width: '14.28%',
        },
        {
          text: 'Disparos',
          value: 'shots',
          width: '14.28%',
        },
        {
          text: 'Recebidos',
          value: 'received',
          width: '14.28%',
        },
        {
          text: 'Taxa de entrega',
          value: 'delivery',
          width: '14.28%',
        },
        {
          text: 'Custo',
          value: 'cost',
          width: '14.28%',
        },
        {
          text: 'Faturamento',
          value: 'revenues',
          width: '14.28%',
        },
      ]
    },
  },

  methods: {
    putEmptyValue,

    shouldShowMessageHistory(channel) {
      if (channel === 'E-mail') {
        return false
      }
      if (channel === 'Whatsapp' && this.$getAllowedModules()['external_whatsapp_provider']) {
        return false
      }
      return true
    },

    putEmptyValueInDeactivatedChannel(value, channel) {
      return this.isChannelActivated(channel) ? value : '-'
    },
  },
}
</script>
